module.exports = __webpack_public_path__ + "templates.facebook-messenger-checkbox-fd800f6c.html";